import React from "react";
import {
  Typography,
  Card,
  Container,
  CardMedia,
  CardContent,
  CardActions,
  Button,
} from "@mui/material";
import { useHistory } from "react-router-dom";
function FeatureCard({
  sx,
  imgSx,
  img,
  innerContainerSx,
  cardTitle,
  cardDesc,
  cardActionText,
}) {
  const history = useHistory();
  return (
    <Card
      onClick={() => {
        history.push("/listings/true");
      }}
      sx={{
        ...sx,
        display: "flex",
        flexFlow: { xs: "column", sm: "row", md: "column" },
        alignItems: { xs: "center" },
        width: { xs: "100%", sm: "720px", md: "384px" },
        // height: { xs: "222px", sm: "154px", md: "306px" },
        borderRadius: "8px",
        padding: { xs: "24px", md: "32px" },
        boxShadow:
          "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        "&:hover": {
          cursor: "pointer",
          transform: "translateY(-5px)",
          boxShadow: "rgb(209 209 213) 0px 5px 15px",
        },
        transition: ".5s ease all",
      }}
    >
      <CardMedia
        sx={{
          ...imgSx,
          objectFit: "contain",
          width: { xs: "240px", sm: "200px", md: "240px" },
          height: { xs: "54px", sm: "96px" },
          margin: { xs: " 0px", sm: "0px 24px", md: " 0px" },
        }}
        component="img"
        src={img}
        alt="card img"
      />
      <Container
        disableGutters={true}
        sx={{
          ...innerContainerSx,
          display: "flex",
          flexFlow: "column",
          marginTop: { xs: "16px", sm: "32px" },
          alignItems: { xs: "center", sm: "start", md: "center" },
          textAlign: { xs: "center", sm: "start", md: "center" },
        }}
      >
        <CardContent sx={{ padding: "0px", margin: "0px" }}>
          <Typography
            gutterBottom
            variant="h3"
            sx={{
              fontWeight: "600",
              fontSize: { xs: "16px", sm: "22px" },
              lineHeight: "26px",
            }}
          >
            {cardTitle}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: "12px", sm: "14px" },
              marginTop: { xs: "4px", sm: "8px" },
              lineHeight: "20px",
            }}
            color="text.secondary"
          >
            {cardDesc}
          </Typography>
        </CardContent>
        <CardActions
          sx={{ padding: "0px", marginTop: { xs: "16px", md: "24px" } }}
        >
          <Button
            sx={{
              width: "fit-content",
              height: "36px",
              borderRadius: "4px",
              borderColor: "#255CCE",
              "&:hover": {
                backgroundColor: "primary.main",
              },
              "&:hover h6": {
                color: "white",
              },
            }}
            variant="outlined"
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                lineHeight: "20px",
                textTransform: "none",
              }}
            >
              {cardActionText}
            </Typography>
          </Button>
        </CardActions>
      </Container>
    </Card>
  );
}

export default FeatureCard;
